import { thcApi } from "@/services/api/apiClient";
import { useEffect } from "react";
import useAuthentication from "./useAuthentication";

export default function useSetApiKey() {
  const { user } = useAuthentication();
  useEffect(() => {
    const token = user?.authentication_token || "";
    thcApi.setToken(token);
  }, [user]);
}
